import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import '../../Internal/Badge/Badge.js';
import { ColorPairTeal } from '../../Internal/Badge/colour-pair.js';
import '../Icon/generated/IconAdd.js';
import '../Icon/generated/IconAddFilled.js';
import '../Icon/generated/IconAddOutline.js';
import '../Icon/generated/IconAddUser.js';
import '../Icon/generated/IconAddressBook.js';
import { IconAllTreatments } from '../Icon/generated/IconAllTreatments.js';
import '../Icon/generated/IconArrowBack.js';
import '../Icon/generated/IconArrowForward.js';
import '../Icon/generated/IconBadgeCheck.js';
import { IconBeard } from '../Icon/generated/IconBeard.js';
import { IconBody } from '../Icon/generated/IconBody.js';
import '../Icon/generated/IconCake.js';
import '../Icon/generated/IconCalendar.js';
import '../Icon/generated/IconCalendarAdd.js';
import '../Icon/generated/IconCalendarDelete.js';
import '../Icon/generated/IconCard.js';
import '../Icon/generated/IconCash.js';
import '../Icon/generated/IconCaution.js';
import '../Icon/generated/IconChat.js';
import '../Icon/generated/IconCheckFilled.js';
import '../Icon/generated/IconCheckOutline.js';
import '../Icon/generated/IconChecked.js';
import '../Icon/generated/IconChevronDown.js';
import '../Icon/generated/IconChevronLeft.js';
import '../Icon/generated/IconChevronLeftOutline.js';
import '../Icon/generated/IconChevronRight.js';
import '../Icon/generated/IconChevronRightOutline.js';
import '../Icon/generated/IconChevronUp.js';
import '../Icon/generated/IconClose.js';
import '../Icon/generated/IconCloseOutline.js';
import '../Icon/generated/IconComment.js';
import '../Icon/generated/IconCompass.js';
import '../Icon/generated/IconConfirmOrDeny.js';
import '../Icon/generated/IconCopy.js';
import '../Icon/generated/IconDiscountFilled.js';
import '../Icon/generated/IconDiscountOutline.js';
import '../Icon/generated/IconEdit.js';
import '../Icon/generated/IconEmail.js';
import '../Icon/generated/IconExpand.js';
import '../Icon/generated/IconExternal.js';
import { IconFace } from '../Icon/generated/IconFace.js';
import '../Icon/generated/IconFilter.js';
import '../Icon/generated/IconGift.js';
import { IconHair } from '../Icon/generated/IconHair.js';
import { IconHairRemoval } from '../Icon/generated/IconHairRemoval.js';
import '../Icon/generated/IconHappy.js';
import '../Icon/generated/IconHeartFilled.js';
import '../Icon/generated/IconHeartOutlined.js';
import '../Icon/generated/IconHelp.js';
import '../Icon/generated/IconHide.js';
import '../Icon/generated/IconHighlights.js';
import '../Icon/generated/IconHome.js';
import '../Icon/generated/IconHomebasedVenue.js';
import '../Icon/generated/IconImage.js';
import '../Icon/generated/IconInfoOutline.js';
import '../Icon/generated/IconLegal.js';
import '../Icon/generated/IconLocation.js';
import '../Icon/generated/IconLock.js';
import '../Icon/generated/IconLogOut.js';
import '../Icon/generated/IconMale.js';
import { IconMassage } from '../Icon/generated/IconMassage.js';
import { IconMedicalDental } from '../Icon/generated/IconMedicalDental.js';
import '../Icon/generated/IconMinusOutline.js';
import '../Icon/generated/IconMobileVenue.js';
import '../Icon/generated/IconMoney.js';
import { IconNails } from '../Icon/generated/IconNails.js';
import '../Icon/generated/IconNewVenue.js';
import '../Icon/generated/IconNotes.js';
import '../Icon/generated/IconOnMap.js';
import '../Icon/generated/IconOptions.js';
import '../Icon/generated/IconPhone.js';
import '../Icon/generated/IconPin.js';
import '../Icon/generated/IconPinOutline.js';
import '../Icon/generated/IconPresentBox.js';
import '../Icon/generated/IconProfile.js';
import '../Icon/generated/IconReceipt.js';
import '../Icon/generated/IconSearch.js';
import '../Icon/generated/IconSecure.js';
import '../Icon/generated/IconSettings.js';
import '../Icon/generated/IconSort.js';
import { IconSpa } from '../Icon/generated/IconSpa.js';
import '../Icon/generated/IconStarFilled.js';
import '../Icon/generated/IconStarOutline.js';
import '../Icon/generated/IconSupport.js';
import '../Icon/generated/IconTeam.js';
import '../Icon/generated/IconTime.js';
import '../Icon/generated/IconTreatwellLogo.js';
import '../Icon/generated/IconUnisex.js';
import '../Icon/generated/IconUser.js';
import '../Icon/generated/IconUserDetails.js';
import '../Icon/generated/IconVenue.js';
import '../Icon/generated/IconView.js';
import '../Icon/generated/IconVoucher.js';
import '../Icon/generated/IconWallet.js';
import '../Icon/generated/IconWarningFilled.js';
import '../Icon/generated/IconWarningOutline.js';
import '../Icon/generated/IconWebsite.js';
import { IconBadge } from '../IconBadge/IconBadge.js';

const icons = {
    treatmentType: {
        2: IconBody,
        4: IconFace,
        6: IconHair,
        43: IconHairRemoval,
        37: IconMassage,
        42: IconMedicalDental,
        36: IconNails,
    },
    treatment: {
        81: IconNails,
        595: IconNails,
    },
    venueType: {
        10: IconFace,
        43: IconBeard,
        48: IconSpa,
    },
};
const TreatmentTypeBadge = ({ colorPair = ColorPairTeal, id, size = 'lg', category = 'treatmentType', }) => {
    const Icon = id !== undefined && icons[category][id] !== undefined
        ? icons[category][id]
        : IconAllTreatments;
    const iconSize = size === 'sm' ? 16 : 24;
    return (jsxRuntimeExports.jsx(IconBadge, { colorPair: colorPair, size: size, icon: jsxRuntimeExports.jsx(Icon, { size: iconSize }) }));
};
TreatmentTypeBadge.displayName = 'TreatmentTypeBadge';

export { TreatmentTypeBadge };
//# sourceMappingURL=TreatmentTypeBadge.js.map
